export default "__VITE_ASSET__DhrFFK31__"